import { render, staticRenderFns } from "./Kalender.vue?vue&type=template&id=6e2c6783"
import script from "./Kalender.vue?vue&type=script&lang=js"
export * from "./Kalender.vue?vue&type=script&lang=js"
import style0 from "./Kalender.vue?vue&type=style&index=0&id=6e2c6783&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports